import { queryOptions } from '@tanstack/react-query'
import { listPlatformServicesOptions, STALE } from '@/shared/api'

/**
 * Сервисы платформы Prima (`GET /platform/services`) — справочник: список меняется редко,
 * поэтому `STALE.reference` (`shared/api/polling.ts` называет «сервисы платформы» прямо в
 * комментарии к этой константе).
 *
 * Слайс `entities/platform`, а не часть `widgets/app-header`: список нужен НЕ только свитчеру
 * сервисов (Task 16) — им же пользуются ссылки «Сервис «Компании»» в поповере компаний
 * (`features/company-switch`) и «Личный кабинет» в меню профиля (тот же виджет, другой узел),
 * а `features → widgets` — импорт снизу вверх, FSD его запрещает. Общий слой ниже виджета
 * и фичи — единственное легальное место для обоих.
 */
export function platformServicesQuery() {
  return queryOptions({
    ...listPlatformServicesOptions(),
    staleTime: STALE.reference,
  })
}
